<template>
    <div class="itips-wrapper">
        <div class="contactus-title">{{ $t('footer15') }}</div>

        <div class="itips-testimonials">
            <div class="itips-container">

                <swiper ref="infoSwiper" :options="swiperOption2">
                    <swiper-slide v-for="(item, index) in swiperData" :key="index">
                        <div>
                            <div class="testimonial-text">{{ $i18n.t(`itips-title${index}`) }}</div>
                            <div class="testimonial-subtext" v-if="item.subtitle">{{ $i18n.t(`itips-subtitle${index}`) }}</div>
                            <div :class="{ 'testimonial-image': true, 'testimonial-image1': index === 0, 'testimonial-image2': index === 1, 'testimonial-image3': index === 2, 'testimonial-image4': index === 3 && $i18n.locale.toLowerCase() === 'en', 'testimonial-image4it': index === 3 && $i18n.locale.toLowerCase() === 'it', 'testimonial-image4de': index === 3 && $i18n.locale.toLowerCase() === 'de', 'testimonial-image4fr': index === 3 && $i18n.locale.toLowerCase() === 'fr', 'testimonial-image4ru': index === 3 && $i18n.locale.toLowerCase() === 'ru', 'testimonial-image5': index === 4 }"></div>
                            <div class="testimonial-info">{{ $i18n.t(`itips-text${index}`) }}</div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>

        <h3>{{ $t('tips0') }}</h3>

        <h4>{{ $t('tips1') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips2') }}<br/><br/>
            {{ $t('tips2-1') }}<br/><br/>
            {{ $t('tips2-2') }}<br/><br/>
            {{ $t('tips2-3') }}
        </div>

        <h4>{{ $t('tips3') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips4') }}<br/><br/>
            {{ $t('tips5') }}
        </div>

        <h4>{{ $t('tips6') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips7') }}<br/><br/>
            {{ $t('tips7-1') }}<br/><br/>
            {{ $t('tips8') }}<br/><br/>
            {{ $t('tips9') }}

            <div class="table-info">{{ $t('tips10') }}</div>
            <div class="table-head">
                <div class="table-left">{{ $t('tips11') }}</div>
                <div class="table-right">{{ $t('tips12') }}</div>
            </div>
            <div class="table-body">
                <div class="table-row">
                    <div class="table-left">95-100</div>
                    <div class="table-right">{{ $t('tips13') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">90–94</div>
                    <div class="table-right">{{ $t('tips14') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">85–89</div>
                    <div class="table-right">{{ $t('tips15') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">80–84</div>
                    <div class="table-right">{{ $t('tips16') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">75–79</div>
                    <div class="table-right">{{ $t('tips17') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">50–74</div>
                    <div class="table-right">{{ $t('tips18') }}</div>
                </div>
            </div>
            <i>{{ $t('tips18-1') }}</i>

            <div class="table-info">{{ $t('tips19') }}</div>
            <div class="table-head">
                <div class="table-left">{{ $t('tips11') }}</div>
                <div class="table-right">{{ $t('tips12') }}</div>
            </div>
            <div class="table-body">
                <div class="table-row">
                    <div class="table-left">20</div>
                    <div class="table-right">{{ $t('tips20') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">19</div>
                    <div class="table-right">{{ $t('tips21') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">18</div>
                    <div class="table-right">{{ $t('tips22') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">17</div>
                    <div class="table-right">{{ $t('tips23') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">16</div>
                    <div class="table-right">{{ $t('tips24') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">15</div>
                    <div class="table-right">{{ $t('tips25') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">14</div>
                    <div class="table-right">{{ $t('tips26') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">13</div>
                    <div class="table-right">{{ $t('tips27') }}</div>
                </div>
                <div class="table-row">
                    <div class="table-left">12</div>
                    <div class="table-right">{{ $t('tips28') }}</div>
                </div>
            </div>
            <i>{{ $t('tips28-1') }}</i>
            <br/><br/>
            {{ $t('tips29') }}
            <br/><br/>
            {{ $t('tips30') }}
            <br/>
            {{ $t('tips31') }}
            <br/>
            {{ $t('tips32') }}
            <br/>
            {{ $t('tips33') }}
            <br/>
            {{ $t('tips34') }}
        </div>

        <h4>{{ $t('tips35') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips36') }}<br/><br/>{{ $t('tips37') }}<br/><br/>{{ $t('tips38') }}<br/><br/>{{ $t('tips39') }}<br/>{{ $t('tips40') }}<br/>{{ $t('tips41') }}<br/>{{ $t('tips42') }}
        </div>

        <h4>{{ $t('tips43') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips44') }}<br/><br/>{{ $t('tips45') }}<br/><br/>{{ $t('tips46') }}
        </div>

        <h4>{{ $t('tips47') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips48') }}<br/><br/>
          {{ $t('tips49') }}
        </div>

        <h4>{{ $t('tips50') }}</h4>
        <div class="itips-wrapper3">
            {{ $t('tips51') }}
            <ul>
                <li>{{ $t('tips52') }}</li>
                <li>{{ $t('tips53') }}</li>
                <li>{{ $t('tips53-1') }}</li>
            </ul>

            {{ $t('tips54') }}<br/><br/>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

    export default {
        name: "InvestmentTips",
        head: {
            title: 'Investment tips | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-app trading-desk'
            }
        },
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        data() {
            return {
                swiperOption2: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                },
                swiperData: [
                    {
                        title: 'Fine wine Market',
                        subtitle: '',
                        info: 'Fine wine as an alternative investment has outperformed most of the major financial Index and is the second highest performing luxury asset class after art.'
                    },
                    {
                        title: 'Fine Wine Performance',
                        subtitle: 'versus traditional financial markets.',
                        info: 'Fine wine as an alternative investment has outperformed most of the major financial Index and is the second highest performing luxury asset class after art.'
                    },
                    {
                        title: 'Demand & Supply',
                        subtitle: '',
                        info: '',
                        info1: 'Wine consumers have become more knowledgeable, thereby aspiring to high quality wines',
                        info2: 'Wealth creation across the world has increasd the demand for expensive wines and opened new markets',
                        info3: 'Fine wine has proved to be a safe yet profitable haven for capital with very low correlation to financial markets',
                    },
                    {
                        title: 'Single bottles performance',
                        subtitle: '',
                        info: 'we will give you detailed information about each wine performance.'
                    },
                    {
                        title: 'Join our community',
                        subtitle: '',
                        info: 'Fine wine as an alternative investment has outperformed most of the major financial Index and is the second highest performing luxury asset class after art.'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .table-info {
        font-weight: bold;
        margin-top: 32px;
    }
    .table-head {
        background: #ccc;
        padding: 5px;
    }
    .table-row {
        padding: 3px;
        border-bottom: 1px solid #ccc;
    }
    .table-left, .table-right {
        display: inline-block;
    }
    .table-left {
        width: 100px;
    }
    .table-right {
        width: calc(100% - 104px);
    }
    .itips-wrapper2 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        text-align: center;
        color: #000000;
        max-width: 785px;
        margin: 0 auto;
    }
    .itips-wrapper3 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        color: #000000;
        max-width: 785px;
        margin: 0 auto;
    }
    .testimonial-info {
        max-width: 880px;
        margin: 0 auto;
    }
    .itips-container {
        max-width: 1366px;
        margin: 0 auto;
    }
    .itips-wrapper {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        background: #ffffff;
        padding: 127px 0 0 0;
    }
    .itips-wrapper h3 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 39.06px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        margin: 37px 0;
    }
    .itips-wrapper h4 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 25px;
        line-height: 120%;
        color: #303030;
        max-width: 785px;
        margin: 60px auto 16px;
    }
    .itips-testimonials {
        background: #F6F6F6;
        height: 649px;
        padding-top: 65px;
    }
    .testimonial-info2w {
        position: relative;
        top: -110px;
        max-width: 970px;
        margin: 0 auto;
    }
    .testimonial-info1,
    .testimonial-info2,
    .testimonial-info3 {
        display: inline-block;
        width: calc((100% - 70px) / 3);
        vertical-align: top;
        text-align: left;
    }
    .testimonial-info1,
    .testimonial-info2 {
        margin-right: 35px;
    }
    .contactus-title {
        text-align: center;
        color: #303030;
        font-size: 49px;
        line-height: 49px;
        font-weight: 300;
        margin-bottom: 47px;
    }
    .testimonial-image {
        width: 904px;
        height: 434px;
        margin: 0 auto;
    }
    .testimonial-image1 {
        background: url('../assets/how/slide1.png') no-repeat center;
        background-size: contain;
    }
    .testimonial-image2 {
        background: url('../assets/how/slide2.png') no-repeat center;
        background-size: contain;
        height: 330px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .testimonial-image3 {
        background: url('../assets/how/slide3.png') no-repeat center;
        background-size: contain;
        position: relative;
        height: 330px;
        margin-top: 20px;
        width: 800px;
    }
    .testimonial-image4 {
        background: url('../assets/how/slide4.png') no-repeat center;
        background-size: contain;
        height: 400px;
    }
    .testimonial-image4it {
        background: url('../assets/how/slide4it.png') no-repeat center;
        background-size: contain;
        height: 400px;
    }
    .testimonial-image4fr {
        background: url('../assets/how/slide4fr.png') no-repeat center;
        background-size: contain;
        height: 400px;
    }
    .testimonial-image4de {
        background: url('../assets/how/slide4de.png') no-repeat center;
        background-size: contain;
        height: 400px;
    }
    .testimonial-image4ru {
        background: url('../assets/how/slide4ru.png') no-repeat center;
        background-size: contain;
        height: 400px;
    }
    .testimonial-image5 {
        background: url('../assets/how/slide5.png') no-repeat center;
        background-size: contain;
        height: 380px;
        margin: 27px auto;
    }
    .testimonial-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 32.83px;
        line-height: 120%;
        text-align: center;
        color: #303030;
    }
    .testimonial-subtext {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        text-align: center;
        color: #000000;
        margin-top: 2px;
    }
    .testimonial-info {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        text-align: center;
        color: #000000;
    }
    .itips-btn {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
        background: #E2C477;
        border-radius: 4px;
        margin: 30px auto 64px;
        width: 357px;
        height: 32px;
        padding: 4px;
    }
    .itips-btn:hover {
        cursor: pointer;
    }

  @media (max-width: 767px) {
    .itips-testimonials {
      display: none;
    }
    .itips-wrapper {
      padding: 127px 16px 0;
    }
    .contactus-title {
      font-size: 36px;
      line-height: 36px;
    }
    .itips-wrapper h3 {
      font-size: 23px;
    }
    .itips-wrapper h4 {
      font-size: 19px;
    }
  }
</style>
<style>
    .page-app .theme--light.v-application {
        background: #ffffff;
    }
    .itips-testimonials .swiper-container {
        text-align: center;
        height: 580px;
    }
    .swiper-pagination-bullet-active {
        opacity: 1;
        background: var(--brand) !important;
    }
    .itips-testimonials .swiper-button-next, .itips-testimonials .swiper-button-prev {
        top: 280px;
    }

    .swiper-container {
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        height: 300px;
        width: 100%;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box;
    }

    .swiper-container-no-flexbox .swiper-slide {
        float: left
    }

    .swiper-container-vertical>.swiper-wrapper {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box
    }

    .swiper-container-android .swiper-slide,.swiper-wrapper {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }

    .swiper-container-multirow>.swiper-wrapper {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap
    }

    .swiper-container-free-mode>.swiper-wrapper {
        transition-timing-function: ease-out;
        margin: 0 auto
    }

    .swiper-slide {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform
    }

    .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 1px solid #F0F0F0;
        padding-left: 0;
        padding-right: 45px;
    }

    .show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 0;
        padding-right: 0;
    }

    .swiper-invisible-blank-slide {
        visibility: hidden
    }

    .swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
        height: auto
    }

    .swiper-container-autoheight .swiper-wrapper {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        transition-property: height,-webkit-transform;
        transition-property: transform,height;
        transition-property: transform,height,-webkit-transform
    }

    .swiper-container-3d {
        -webkit-perspective: 1200px;
        perspective: 1200px
    }

    .swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d
    }

    .swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10
    }

    .swiper-container-3d .swiper-slide-shadow-left {
        background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-right {
        background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-top {
        background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-bottom {
        background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
        -ms-touch-action: pan-y;
        touch-action: pan-y
    }

    .swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
        -ms-touch-action: pan-x;
        touch-action: pan-x
    }

    .swiper-button-next,.swiper-button-prev {
        position: absolute;
        top: 50%;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-size: 27px 44px;
        background-position: 50%;
        background-repeat: no-repeat
    }

    .swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
        opacity: .35;
        cursor: auto;
        pointer-events: none
    }

    .swiper-button-prev,.swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
        left: 50px;
        right: auto
    }

    .swiper-button-next,.swiper-container-rtl .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
        right: 50px;
        left: auto
    }

    .swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
    }

    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: opacity .3s;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        z-index: 10
    }

    .swiper-pagination.swiper-pagination-hidden {
        opacity: 0
    }

    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 10px;
        left: 0;
        width: 100%
    }

    .swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        -webkit-transform: scale(.33);
        transform: scale(.33);
        position: relative
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
        background: #000;
        opacity: .2
    }

    button.swiper-pagination-bullet {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none
    }

    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
        background: #007aff
    }

    .swiper-container-vertical>.swiper-pagination-bullets {
        right: 10px;
        top: 50%;
        -webkit-transform: translate3d(0,-50%,0);
        transform: translate3d(0,-50%,0)
    }

    .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 6px 0;
        display: block
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 8px
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        display: inline-block;
        transition: top .2s,-webkit-transform .2s;
        transition: transform .2s,top .2s;
        transition: transform .2s,top .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 4px
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        white-space: nowrap
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: left .2s,-webkit-transform .2s;
        transition: transform .2s,left .2s;
        transition: transform .2s,left .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: right .2s,-webkit-transform .2s;
        transition: transform .2s,right .2s;
        transition: transform .2s,right .2s,-webkit-transform .2s
    }

    .swiper-pagination-progressbar {
        background: rgba(0,0,0,.25);
        position: absolute
    }

    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        background: #007aff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: left top;
        transform-origin: left top
    }

    .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        -webkit-transform-origin: right top;
        transform-origin: right top
    }

    .swiper-container-horizontal>.swiper-pagination-progressbar {
        width: 100%;
        height: 4px;
        left: 0;
        top: 0
    }

    .swiper-container-vertical>.swiper-pagination-progressbar {
        width: 4px;
        height: 100%;
        left: 0;
        top: 0
    }

    .swiper-pagination-white .swiper-pagination-bullet-active {
        background: #fff
    }

    .swiper-pagination-progressbar.swiper-pagination-white {
        background: hsla(0,0%,100%,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
        background: #fff
    }

    .swiper-pagination-black .swiper-pagination-bullet-active {
        background: #000
    }

    .swiper-pagination-progressbar.swiper-pagination-black {
        background: rgba(0,0,0,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
        background: #000
    }

    .swiper-scrollbar {
        border-radius: 10px;
        position: relative;
        -ms-touch-action: none;
        background: rgba(0,0,0,.1)
    }

    .swiper-container-horizontal>.swiper-scrollbar {
        position: absolute;
        left: 1%;
        bottom: 3px;
        z-index: 50;
        height: 5px;
        width: 98%
    }

    .swiper-container-vertical>.swiper-scrollbar {
        position: absolute;
        right: 3px;
        top: 1%;
        z-index: 50;
        width: 5px;
        height: 98%
    }

    .swiper-scrollbar-drag {
        height: 100%;
        width: 100%;
        position: relative;
        background: rgba(0,0,0,.5);
        border-radius: 10px;
        left: 0;
        top: 0
    }

    .swiper-scrollbar-cursor-drag {
        cursor: move
    }

    .swiper-zoom-container {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center
    }

    .swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
        max-width: 100%;
        max-height: 100%;
        -o-object-fit: contain;
        object-fit: contain
    }

    .swiper-slide-zoomed {
        cursor: move
    }

    .swiper-lazy-preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        -webkit-transform-origin: 50%;
        transform-origin: 50%;
        -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
        animation: swiper-preloader-spin 1s steps(12) infinite
    }

    .swiper-lazy-preloader:after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
        background-position: 50%;
        background-size: 100%;
        background-repeat: no-repeat
    }

    .swiper-lazy-preloader-white:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
    }

    @-webkit-keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    .swiper-container .swiper-notification {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        opacity: 0;
        z-index: -1000
    }

    .swiper-container-fade.swiper-container-free-mode .swiper-slide {
        transition-timing-function: ease-out
    }

    .swiper-container-fade .swiper-slide {
        pointer-events: none;
        transition-property: opacity
    }

    .swiper-container-fade .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube {
        overflow: visible
    }

    .swiper-container-cube .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1;
        visibility: hidden;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        width: 100%;
        height: 100%
    }

    .swiper-container-cube .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-cube.swiper-container-rtl .swiper-slide {
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
        pointer-events: auto;
        visibility: visible
    }

    .swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-cube .swiper-cube-shadow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .6;
        -webkit-filter: blur(50px);
        filter: blur(50px);
        z-index: 0
    }

    .swiper-container-flip {
        overflow: visible
    }

    .swiper-container-flip .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1
    }

    .swiper-container-flip .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-coverflow .swiper-wrapper {
        -ms-perspective: 1200px
    }
</style>
